module.exports = __webpack_public_path__ + "img/add_icon.6c341fa2.png";